import ProductPromotions from './ProductPromotions'
export default ProductPromotions
